module.exports = __webpack_public_path__ + "img/yaoyao.6b77a462.png";